









































































































import EcgIcon from '@/utils/ecg-icon.vue'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {
    EcgIcon,
  },
})
export default class ModalSolicitacaoCirurgiaAvaliacaoPreOperatoria extends Vue {
  @Prop() country: string
  @Prop() label: string
  @Prop() cellphone: string
  @Prop() handler: string
  @Prop() data: any
  @Prop() detailsDisabled: boolean

  usarRecurso: boolean = false
  pacienteNotificado: boolean = false
  showQuestion: boolean = true

  @Emit('close')
  closeModal() {}

  @Emit('esc')
  escClick() {}

  habilitaNotificacao() {
    if (!this.usarRecurso) {
      this.pacienteNotificado = false
    }
  }

  @Watch('usarRecurso')
  onUsarRecursoChanged() {
    this.emitParam()
  }

  @Watch('pacienteNotificado')
  onPacienteNotificadoChanged() {
    this.emitParam()
  }

  emitParam() {
    if (this.usarRecurso && this.pacienteNotificado) {
      this.$emit('preference', true)
    } else {
      this.$emit('preference', false)
    }
  }

  mounted() {
    this.usarRecurso = true
    this.pacienteNotificado = false
    if (this.data.apa.notificacaoEnviada) {
      this.showQuestion = false
    }
  }
}
